module.exports = __webpack_public_path__ + "static/media/rexel_logo_min.06c681c0.png";